(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  // Trilho sem pontas para o destaque ("Elas usam"), no molde do slider
  // em loop da seção de vídeos da Onça Preta (Swiper com loop e slide
  // centralizado): as fotos repetem dos dois lados, a seta anda um cartão
  // e o trilho nunca chega no fim. Nada anda sozinho. É rolagem de
  // verdade, não transform, porque o destaque do centro é uma animação
  // por scroll e continua valendo.
  function loopGalleryRail(rail) {
    if (rail.dataset.loop) return;
    rail.dataset.loop = 'on';
    const originals = Array.from(rail.children);
    if (originals.length < 2) return;

    // Duas cópias além da original: dá para arrastar nos dois sentidos
    // sem ver o fim. As cópias não entram na leitura nem na tabulação.
    for (let copy = 0; copy < 2; copy += 1) {
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach((el) => { el.tabIndex = -1; });
        rail.append(clone);
      });
    }

    const count = originals.length;
    const left = (el) => el.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
    // Largura de uma cópia medida entre dois cartões iguais, para pular
    // exatamente um período mesmo com largura de cartão quebrada.
    let width = left(rail.children[count]) - left(rail.children[0]);
    new ResizeObserver(() => { width = left(rail.children[count]) - left(rail.children[0]); }).observe(rail);

    // Sempre na cópia do meio: pular uma cópia inteira não muda nada na
    // tela, porque as três são iguais.
    const wrap = (x) => {
      if (x < width) return x + width;
      if (x >= width * 2) return x - width;
      return x;
    };

    // Abre com o cartão do meio da cópia do meio no centro, como o
    // desenho (17117:14791).
    const mid = rail.children[count + Math.floor(count / 2)];
    rail.scrollLeft = left(mid) - (rail.clientWidth - mid.offsetWidth) / 2;

    // O pulo só acontece com o trilho parado: gravar scrollLeft no meio
    // de uma rolagem suave (seta) ou da inércia (dedo) interromperia o
    // movimento. Sem scrollend no navegador, vale a pausa nos eventos.
    let settle = 0;
    const rest = () => {
      const wrapped = wrap(rail.scrollLeft);
      if (wrapped !== rail.scrollLeft) rail.scrollLeft = wrapped;
    };
    rail.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(rest, 150);
    }, { passive: true });
    rail.addEventListener('scrollend', () => {
      clearTimeout(settle);
      rest();
    });
  }

  function loopGalleryRails(root) {
    root.querySelectorAll('.gallery--emphasis .gallery__rail').forEach(loopGalleryRail);
  }

  loopGalleryRails(document);
  document.addEventListener('shopify:section:load', (event) => loopGalleryRails(event.target));

  } catch(e) { console.error(e); }
})();
})();
